import { createExitBreakPlugin as createPlateExitBreakPlugin, KEY_EXIT_BREAK } from '@udecode/plate-break';
import {
  ELEMENT_BLOCKQUOTE,
  ELEMENT_BUTTON,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_PARAGRAPH,
} from '../../pluginKeys';

export const createExitBreakPlugin = () => createPlateExitBreakPlugin({
  key: KEY_EXIT_BREAK,
  options: {
    rules: [
      {
        hotkey: 'mod+enter',
        level: 1,
        defaultType: ELEMENT_PARAGRAPH,
      },
      {
        hotkey: 'mod+shift+enter',
        before: true,
        level: 1,
        defaultType: ELEMENT_PARAGRAPH,
      },
      {
        hotkey: 'enter',
        query: {
          start: true,
          end: true,
          allow: [ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_BUTTON],
        },
        // https://github.com/udecode/plate/blob/main/packages/editor/break/src/exit-break/onKeyDownExitBreak.ts
        // Find path.next at selectionPath.slice(0, level + 1) = slice(0, -1)
        // If selection at [0,0,0] (text leaf node), will find Path.next([0, 0])
        level: -2,
        defaultType: ELEMENT_PARAGRAPH,
      },
      {
        hotkey: 'enter',
        query: {
          end: true,
          allow: [ELEMENT_BLOCKQUOTE],
        },
        level: -2,
        defaultType: ELEMENT_PARAGRAPH,
      },
    ],
  },
});
